<script setup lang="ts">
const props = defineProps<{
  appendPaths?: { link?: string, name: string }[]
}>()

const paths = computed(() => [
  { link: '/content', name: 'TikTok资讯' },
  ...props?.appendPaths ?? [],
])
</script>

<template>
  <nav flex items-center text-14px class="text-[var(--color-grey-1)]">
    当前位置:
    <ElBreadcrumb separator=">" ml-4px>
      <ElBreadcrumbItem
        style="
          --el-text-color-primary: var(--color-grey-1); --el-color-primary: var(--color-2);
          --el-text-color-regular: var(--color-1);
        "
        class="breadcrumb"
      >
        <a href="/">首页</a>
      </ElBreadcrumbItem>
      <ElBreadcrumbItem
        v-for="(path, i) in paths"
        :key="i"
        style="
          --el-text-color-primary: var(--color-grey-1); --el-color-primary: var(--color-2);
          --el-text-color-regular: var(--color-1);
        "
        class="breadcrumb"
        :to="path.link && i < paths.length - 1 ? { path: path.link } : undefined"
      >
        {{ path.name }}
      </ElBreadcrumbItem>
    </ElBreadcrumb>
  </nav>
</template>

<style scoped lang="scss">
.breadcrumb {
  &:deep(span), &:deep(a) {
    font-weight: 400;
  }

  &:deep(.el-breadcrumb__separator) {
    margin: 0 4px;
  }
}
</style>
